import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <FaqSection />

        <TopicsSection />

        <UpdatesSection />

        <FeaturesSection />

        <AppSection />

        <MediaSection />

        <AboutSection />

        <RankingSection />

        <IndexSection />

        <CarouselSection />

        <ContactSection />

        <CommentsSection />

        <CardsSection />
      </main>

      <Footer />
    </div>
  );
}